import { getMemberIdWithFallback } from '@trello/authentication';
import { useWaitOnQuery } from '@trello/quickload';

import { MemberAtlassianIdDocument } from './MemberAtlassianIdQuery.generated';

/**
 * React hook that retrieves the current member's Atlassian Account ID (aaId)
 * by querying the local Apollo cache using the member's Trello ID.
 *
 * @param options - Configuration options for the hook.
 * @param options.skip - When `true`, skips executing the underlying GraphQL query.
 * @returns An object containing `aaId`, the member's Atlassian Account ID,
 * or `undefined` if the query was skipped or the data is unavailable.
 */
export const useMemberAtlassianId = ({
  skip,
}: {
  skip?: boolean;
}): { aaId?: string } => {
  const memberId = getMemberIdWithFallback();
  const { data } = useWaitOnQuery(MemberAtlassianIdDocument, {
    variables: { memberId },
    waitOn: ['MemberHeader'],
    skip,
    context: {
      operationName: 'MemberAtlassianId',
      document: MemberAtlassianIdDocument,
    },
  });
  return {
    aaId: data?.member?.aaId || undefined,
  };
};
